import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

/** Asks the user for an access reason to a scope: emits `true` once one is submitted, `false` when declined. */
export interface AccessReasonGate {
  request(scopeId: string): Observable<boolean>;
}

/** Declines every request, for applications that provide no gate. */
export class NoopAccessReasonGate implements AccessReasonGate {
  public request(): Observable<boolean> {
    return of(false);
  }
}

export const ACCESS_REASON_GATE = new InjectionToken<AccessReasonGate>('access-reason-gate', {
  providedIn: 'root',
  factory: () => new NoopAccessReasonGate(),
});
